export default "import React from 'react';\nimport { Tooltip } from 'mj-design';\n\nexport default () => (\n  <Tooltip />\n);\n";